export default {
  PATCH_REDIRECT: 'Redirecting to minor from patch',
  VERSION_GROUP_REDIRECT: 'Redirecting to minor from version group'
};
